export function getTooltipHtml (content, title) {
  content = content.map(item => {
    return `
      <span class="chart-left">${item[0]}</span>
      <span class="chart-right chart-value">${item[1]}</span>
    `
  })

  if (title) {
    content.unshift(`<span class="chart-title">${title}</span>`)
  }
  return `<div class="chart_tooltip">${content.join('<br>')}</div>`
}
